import Vue from "vue"
import Vuetify from "vuetify/lib/framework"
import ClearChoiceIcons from "../assets/clearchoice/icons/clearchoiceiconsprite"
import "@mdi/font/css/materialdesignicons.css" // Ensure you are using css-loader
import { icon } from "@fortawesome/fontawesome-svg-core"

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        defaultTheme: "clearchoice",
        themes: {
            light: {
                primary: "#002855",
                secondary: "#004BB9",
                accent: "#CF2A2A",
                info: "#B9DEFA",
                success: "#A4E2B4",
                warning: "#FFEC9F",
                anchor: "#004BB9",
            },
        },
    },
    icons: {
        iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg',
        values: ClearChoiceIcons,
        // <v-icon></v-icon>
    },
})
